/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TUpdateConfigRequest,
  TUpdateConfigModel,
  IMappers,
  TUpdateConfigResponse,
  TUpdateConfigResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createUpdateConfigModel(parameters: TUpdateConfigRequest): TUpdateConfigModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'promotions-flow-control',
    pathApi: '/v1/update-config/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IUpdateConfigOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TUpdateConfigRequest;
}

export async function fetchUpdateConfig<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUpdateConfigOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUpdateConfigResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUpdateConfigModel(parameters),
    config,
  )) as FetchResponse<TUpdateConfigResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TUpdateConfigResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUpdateConfigResponse>;
}
